import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";
/**
 * Reveals its contents with a fade-and-rise animation the first time the
 * target enters the viewport.
 */
const Reveal = React.forwardRef(({ children, className, delay = 0, eager = false, threshold = 0.15, style, asChild = false, ...props }, forwardedRef) => {
    const elementRef = React.useRef(null);
    const [isVisible, setIsVisible] = React.useState(false);
    React.useEffect(() => {
        const element = elementRef.current;
        if (!element)
            return;
        if (eager) {
            setIsVisible(true);
            return;
        }
        if (typeof IntersectionObserver === "undefined") {
            setIsVisible(true);
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, { threshold, rootMargin: "0px 0px -40px 0px" });
        observer.observe(element);
        return () => observer.disconnect();
    }, [eager, threshold]);
    const setRefs = (element) => {
        elementRef.current = element;
        if (typeof forwardedRef === "function") {
            forwardedRef(element);
        }
        else if (forwardedRef) {
            forwardedRef.current = element;
        }
    };
    const Comp = asChild ? Slot : "div";
    return (_jsx(Comp, { ref: setRefs, className: cn("translate-y-9 opacity-0 transition-[opacity,transform,translate] duration-[900ms] ease-out motion-reduce:translate-y-0 motion-reduce:transition-none", isVisible && "translate-y-0 opacity-100", className), style: { ...style, transitionDelay: `${delay}s` }, ...props, children: children }));
});
Reveal.displayName = "Reveal";
export { Reveal };
//# sourceMappingURL=reveal.js.map